import { useEffect, useRef, useCallback } from "react";

export const useInterval = (callback, delay) => {
    const savedCallback = useRef();
    const intervalId = useRef(null);
  
    useEffect(() => {
      savedCallback.current = callback;
    });
  
    useEffect(() => {
      function tick() {
        savedCallback.current();
      }
  
      if (delay !== null) {
        setTimeout(tick, 0)
        intervalId.current = setInterval(tick, delay);
        return () => clearInterval(intervalId.current);
      }
    }, [delay]);

    const clear = useCallback(() => {
      if (intervalId.current) {
        clearInterval(intervalId.current);
        intervalId.current = null;
      }
    }, []);

    return clear;
}

export const useTimeout = (callback, delay) => {
  const timeoutRef = useRef();
  const callbackRef = useRef(callback);

  // 콜백이 변경될 때마다 ref 업데이트
  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  // 타이머 설정 함수
  const set = useCallback(() => {
    if (delay === null) return;
    
    timeoutRef.current = setTimeout(() => callbackRef.current(), delay);
  }, [delay]);

  // 타이머 제거 함수
  const clear = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }, []);

  // 타이머 리셋 함수
  const reset = useCallback(() => {
    clear();
    set();
  }, [clear, set]);

  // 컴포넌트 마운트/delay 변경 시 타이머 설정
  useEffect(() => {
    set();
    return clear; // cleanup 함수로 타이머 제거
  }, [delay, set, clear]);

  return { reset, clear };
}

export default useTimeout;